import { TabMetricSectionLayout } from 'modules';

import { Typography } from '@mui/material';
import * as ds from './dataService';



export type CompanyOverviewSectionProps = {
  listedCompanyId: string;
};

export const FC = (props: CompanyOverviewSectionProps) => {
  const { data, loading } = ds.useQuery(props.listedCompanyId);

  return (
    <TabMetricSectionLayout.FC
      title='Company Overview'
    >
      {data.fields.map((field, i) => (
        <Typography key={i} variant='activitySubHeaderPrimary'>{field.label}</Typography>
      ))}
    </TabMetricSectionLayout.FC>
  );
};
